import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle2 } from 'lucide-react';

export function BetaAccessThankYou() {
  return (
    <Card className="max-w-lg mx-auto">
      <CardHeader className="text-center pb-2">
        <div className="flex justify-center mb-4">
          <CheckCircle2 className="h-12 w-12 text-green-500" />
        </div>
        <CardTitle className="text-xl">Thank You!</CardTitle>
      </CardHeader>
      <CardContent className="text-center space-y-3">
        <p className="text-muted-foreground">
          Your request to join the Fias closed beta has been submitted successfully.
        </p>
        <p className="text-muted-foreground">
          Our team will review your application and get back to you via email. If accepted, you will
          receive an invite code that you can use to create your Fias account.
        </p>
        <p className="text-sm text-muted-foreground mt-4">
          This process typically takes a few business days.
        </p>
      </CardContent>
    </Card>
  );
}
